import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import clxBind from 'classnames/bind';
import Row from '../Row';
import Col from '../Col';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class FormRow extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    layout: PropTypes.oneOf(['vertical', 'horizontal', 'inline']),
    className: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    layout: undefined,
    className: undefined,
  };

  static contextTypes = {
    form: PropTypes.shape({
      layout: PropTypes.oneOf(['vertical', 'horizontal', 'inline']),
    }),
  };

  getLayout = () => {
    const { layout: propsLayout } = this.props;
    const contextLayout = get(this.context, 'form.layout');

    return propsLayout || contextLayout;
  };

  isInline = () => this.getLayout() === 'inline';

  isVertical = () => this.getLayout() === 'vertical';

  render() {
    const { children, className } = this.props;
    const isInline = this.isInline();

    if (isInline) {
      return <span className={clx('inline', className)}>{children}</span>;
    }

    const spacing = this.isVertical() ? 'md' : 'lg';

    return (
      <Row vSpacing={spacing} vColSpacing={spacing}>
        <Col>{children}</Col>
      </Row>
    );
  }
}
